<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 顶部栏 -->
      <div class="topbar">
        <el-input
          v-model="search"
          size="small"
          placeholder=""
          prefix-icon="el-icon-search"
        />
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click.stop="addDiagnosisGroup()"
        >
          新增诊疗圈
        </el-button>
      </div>
      <!-- 内容 -->
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%; margin-bottom: 20px"
      >
        <el-table-column prop="col1" label="#" align="center" width="100" />
        <el-table-column prop="col6" label="序列号" align="center" />
        <el-table-column prop="col7" label="创建时间" align="center" />
        <el-table-column
          prop="col5"
          label="管理员昵称"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="col2"
          label="基层检查机构"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="col3"
          label="上级诊断机构"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="col4"
          label="圈子名称"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="col8"
          label="圈子描述"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column label="操作" align="center" width="350">
          <template slot-scope="scope">
            <el-button
              size="small"
              :type="scope.row.isEnabled ? 'warning' : 'success'"
              @click.stop="certificationExpert(scope.$index, scope.row)"
            >
              {{ scope.row.isEnabled ? '禁用' : '启用' }}
            </el-button>
            <el-button
              size="small"
              type="primary"
              @click.stop="openQRCodeDialog(scope.$index, scope.row)"
            >
              查看二维码
            </el-button>
            <el-button
              size="small"
              type="primary"
              @click.stop="editDiagnosisGroup(scope.$index, scope.row)"
            >
              编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click.stop="deleteDiagnosisGroup(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background layout="prev, pager, next" :total="100" />
    </el-card>

    <!-- addDiagnosisGroupDialog -->
    <el-dialog
      title="新增诊疗圈"
      :visible.sync="addDiagnosisGroupDialog"
      width="30%"
    >
      <el-form :model="form">
        <el-form-item label="基层检查机构名称" label-width="130px">
          <el-input v-model="form.col1" />
        </el-form-item>
        <el-form-item label="上级诊断机构名称" label-width="130px">
          <el-input v-model="form.col2" />
        </el-form-item>
        <el-form-item label="分级诊疗圈名称" label-width="130px">
          <el-input v-model="form.col3" />
        </el-form-item>
        <el-form-item label="分级管理员账号" label-width="130px">
          <el-input v-model="form.col4" />
        </el-form-item>
        <el-form-item label="分级诊疗圈简介" label-width="130px">
          <el-input v-model="form.col5" type="textarea" rows="3" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="addDiagnosisGroupDialog = false">
          取 消
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="addDiagnosisGroupDialog = false"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- editDiagnosisGroupDialog -->
    <el-dialog
      title="编辑诊疗圈"
      :visible.sync="editDiagnosisGroupDialog"
      width="30%"
    >
      <el-form :model="form">
        <el-form-item label="基层检查机构名称" label-width="130px">
          <el-input v-model="form.col1" />
        </el-form-item>
        <el-form-item label="上级诊断机构名称" label-width="130px">
          <el-input v-model="form.col2" />
        </el-form-item>
        <el-form-item label="分级诊疗圈名称" label-width="130px">
          <el-input v-model="form.col3" />
        </el-form-item>
        <el-form-item label="分级管理员账号" label-width="130px">
          <el-input v-model="form.col4" />
        </el-form-item>
        <el-form-item label="分级诊疗圈简介" label-width="130px">
          <el-input v-model="form.col5" type="textarea" rows="3" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editDiagnosisGroupDialog = false">
          取 消
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="editDiagnosisGroupDialog = false"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- 查看二维码 -->
    <el-dialog title="查看二维码" :visible.sync="QRCodeDialog" width="25%">
      <img :src="QRCodeSrc" width="100%" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      QRCodeSrc: '',
      QRCodeDialog: false,
      addDiagnosisGroupDialog: false,
      editDiagnosisGroupDialog: false,
      tableData: [
        {
          isEnabled: false,
          col1: '634',
          col2: 'test06基层检查机构名称',
          col3: 'test06基层检查机构名称',
          col4: 'test06诊疗组',
          col5: '帝都温度传感水电费水电费',
          col6: '62367260',
          col7: '2019-08-05 14:37:34',
          col8: '分级诊疗圈简介',
          src:
            'https://upload.wikimedia.org/wikipedia/commons/f/f2/%E7%BB%B4%E5%9F%BA%E4%B8%AD%E6%96%87%E7%A4%BE%E5%8A%A0%E7%BE%A4%E4%BA%8C%E7%BB%B4%E7%A0%81.png'
        },
        {
          isEnabled: false,
          col1: '634',
          col2: 'test06基层检查机构名称',
          col3: 'test06基层检查机构名称',
          col4: 'test06诊疗组',
          col5: '帝都温度传感水电费水电费',
          col6: '62367260',
          col7: '2019-08-05 14:37:34',
          col8: '分级诊疗圈简介',
          src:
            'https://upload.wikimedia.org/wikipedia/commons/f/f2/%E7%BB%B4%E5%9F%BA%E4%B8%AD%E6%96%87%E7%A4%BE%E5%8A%A0%E7%BE%A4%E4%BA%8C%E7%BB%B4%E7%A0%81.png'
        },
        {
          isEnabled: true,
          col1: '634',
          col2: 'test06基层检查机构名称',
          col3: 'test06基层检查机构名称',
          col4: 'test06诊疗组',
          col5: '帝都温度传感水电费水电费',
          col6: '62367260',
          col7: '2019-08-05 14:37:34',
          col8: '分级诊疗圈简介',
          src:
            'https://upload.wikimedia.org/wikipedia/commons/f/f2/%E7%BB%B4%E5%9F%BA%E4%B8%AD%E6%96%87%E7%A4%BE%E5%8A%A0%E7%BE%A4%E4%BA%8C%E7%BB%B4%E7%A0%81.png'
        },
        {
          isEnabled: false,
          col1: '634',
          col2: 'test06基层检查机构名称',
          col3: 'test06基层检查机构名称',
          col4: 'test06诊疗组',
          col5: '帝都温度传感水电费水电费',
          col6: '62367260',
          col7: '2019-08-05 14:37:34',
          col8: '分级诊疗圈简介',
          src:
            'https://upload.wikimedia.org/wikipedia/commons/f/f2/%E7%BB%B4%E5%9F%BA%E4%B8%AD%E6%96%87%E7%A4%BE%E5%8A%A0%E7%BE%A4%E4%BA%8C%E7%BB%B4%E7%A0%81.png'
        },
        {
          isEnabled: false,
          col1: '634',
          col2: 'test06基层检查机构名称',
          col3: 'test06基层检查机构名称',
          col4: 'test06诊疗组',
          col5: '帝都温度传感水电费水电费',
          col6: '62367260',
          col7: '2019-08-05 14:37:34',
          col8: '分级诊疗圈简介',
          src:
            'https://upload.wikimedia.org/wikipedia/commons/f/f2/%E7%BB%B4%E5%9F%BA%E4%B8%AD%E6%96%87%E7%A4%BE%E5%8A%A0%E7%BE%A4%E4%BA%8C%E7%BB%B4%E7%A0%81.png'
        },
        {
          isEnabled: false,
          col1: '634',
          col2: 'test06基层检查机构名称',
          col3: 'test06基层检查机构名称',
          col4: 'test06诊疗组',
          col5: '帝都温度传感水电费水电费',
          col6: '62367260',
          col7: '2019-08-05 14:37:34',
          col8: '分级诊疗圈简介',
          src:
            'https://upload.wikimedia.org/wikipedia/commons/f/f2/%E7%BB%B4%E5%9F%BA%E4%B8%AD%E6%96%87%E7%A4%BE%E5%8A%A0%E7%BE%A4%E4%BA%8C%E7%BB%B4%E7%A0%81.png'
        },
        {
          isEnabled: false,
          col1: '634',
          col2: 'test06基层检查机构名称',
          col3: 'test06基层检查机构名称',
          col4: 'test06诊疗组',
          col5: '帝都温度传感水电费水电费',
          col6: '62367260',
          col7: '2019-08-05 14:37:34',
          col8: '分级诊疗圈简介',
          src:
            'https://upload.wikimedia.org/wikipedia/commons/f/f2/%E7%BB%B4%E5%9F%BA%E4%B8%AD%E6%96%87%E7%A4%BE%E5%8A%A0%E7%BE%A4%E4%BA%8C%E7%BB%B4%E7%A0%81.png'
        },
        {
          isEnabled: false,
          col1: '634',
          col2: 'test06基层检查机构名称',
          col3: 'test06基层检查机构名称',
          col4: 'test06诊疗组',
          col5: '帝都温度传感水电费水电费',
          col6: '62367260',
          col7: '2019-08-05 14:37:34',
          col8: '分级诊疗圈简介',
          src:
            'https://upload.wikimedia.org/wikipedia/commons/f/f2/%E7%BB%B4%E5%9F%BA%E4%B8%AD%E6%96%87%E7%A4%BE%E5%8A%A0%E7%BE%A4%E4%BA%8C%E7%BB%B4%E7%A0%81.png'
        },
        {
          isEnabled: true,
          col1: '634',
          col2: 'test06基层检查机构名称',
          col3: 'test06基层检查机构名称',
          col4: 'test06诊疗组',
          col5: '帝都温度传感水电费水电费',
          col6: '62367260',
          col7: '2019-08-05 14:37:34',
          col8: '分级诊疗圈简介',
          src:
            'https://upload.wikimedia.org/wikipedia/commons/f/f2/%E7%BB%B4%E5%9F%BA%E4%B8%AD%E6%96%87%E7%A4%BE%E5%8A%A0%E7%BE%A4%E4%BA%8C%E7%BB%B4%E7%A0%81.png'
        },
        {
          isEnabled: false,
          col1: '634',
          col2: 'test06基层检查机构名称',
          col3: 'test06基层检查机构名称',
          col4: 'test06诊疗组',
          col5: '帝都温度传感水电费水电费',
          col6: '62367260',
          col7: '2019-08-05 14:37:34',
          col8: '分级诊疗圈简介',
          src:
            'https://upload.wikimedia.org/wikipedia/commons/f/f2/%E7%BB%B4%E5%9F%BA%E4%B8%AD%E6%96%87%E7%A4%BE%E5%8A%A0%E7%BE%A4%E4%BA%8C%E7%BB%B4%E7%A0%81.png'
        }
      ],
      form: {
        col1: '',
        col2: '',
        col3: '',
        col4: '',
        col5: ''
      }
    }
  },
  methods: {
    /**
     *
     */
    openQRCodeDialog(index, row) {
      this.QRCodeSrc = this.tableData[index].src
      this.QRCodeDialog = true
    },
    /**
     *
     */
    addDiagnosisGroup() {
      this.addDiagnosisGroupDialog = true
    },
    /**
     *
     */
    editDiagnosisGroup() {
      this.editDiagnosisGroupDialog = true
    },

    /**
     *
     */
    deleteDiagnosisGroup(index, row) {
      console.log(index, row)
      this.$confirm('是否删除该诊疗圈', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
        })
        .catch(() => {
          this.$message('取消操作')
        })
    }
  }
}
</script>

<style scoped lang="scss"></style>
